import React, { useState } from 'react'
import { Info } from 'lucide-react'
import { cn } from '../lib/utils.ts'

interface InfoTipProps {
  text: string
  className?: string
}

/** Small inline help icon that shows a plain-English explanation on hover/focus. */
export default function InfoTip({ text, className = '' }: InfoTipProps) {
  const [open, setOpen] = useState(false)

  return (
    <span
      className={cn('relative inline-flex items-center', className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={e => e.preventDefault()}
        className="text-gray-400 hover:text-gray-600 focus:outline-none"
        aria-label={text}
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute z-20 bottom-full left-1/2 -translate-x-1/2 mb-1.5 w-56 rounded-md bg-gray-900 px-2.5 py-1.5 text-xs leading-snug text-white shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  )
}
